'use client';
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o);
}
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t)
    return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i))
        return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
} return ("string" === r ? String : Number)(t); }
import React, { useState, useEffect } from 'react';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import ColorPickerArea from './ColorPickerArea';
import HuePicker from './HuePicker';
import ColorValues from './ColorValues';
import { hexToRgb, rgbToHsv } from './colorUtils';
import { Button } from '@mui/material';
import { constants } from '../../constants';
var Container = styled(Paper)(function (_ref) {
    var theme = _ref.theme;
    return _defineProperty(_defineProperty({
        display: 'flex',
        width: '364px',
        padding: '24px',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '16px',
        flexShrink: 0,
        borderRadius: '12px',
        border: '1px solid #EBEBEB',
        boxShadow: 'none',
        fontFamily: '"Open Sans", -apple-system, Roboto, Helvetica, sans-serif',
        backgroundColor: '#fff'
    }, theme.breakpoints.down('md'), {
        width: '100%',
        maxWidth: '364px',
        margin: '0 auto'
    }), theme.breakpoints.down('sm'), {
        width: '100%',
        height: 'auto',
        padding: '12px',
        gap: '12px'
    });
});
var PickerFull = function PickerFull(_ref3) {
    var setColor = _ref3.setColor, defaultColor = _ref3.defaultColor;
    var _useState = useState(defaultColor !== null && defaultColor !== void 0 ? defaultColor : '#E89623'), _useState2 = _slicedToArray(_useState, 1), initialHex = _useState2[0];
    var initialRgb = hexToRgb(initialHex);
    var initialHsv = rgbToHsv(initialRgb.r, initialRgb.g, initialRgb.b);
    var _useState3 = useState({
        hex: initialHex,
        rgb: initialRgb,
        hsv: initialHsv
    }), _useState4 = _slicedToArray(_useState3, 2), currentColor = _useState4[0], setCurrentColor = _useState4[1];
    // Calculate initial positions based on HSV values
    var initialSaturationX = initialHsv.s / 100 * 319;
    var initialBrightnessY = 238 - initialHsv.v / 100 * 238;
    var initialHueX = initialHsv.h / 360 * 320;
    var _useState5 = useState({
        x: initialSaturationX,
        y: initialBrightnessY
    }), _useState6 = _slicedToArray(_useState5, 2), pickerPosition = _useState6[0], setPickerPosition = _useState6[1];
    var _useState7 = useState(initialHueX), _useState8 = _slicedToArray(_useState7, 2), huePosition = _useState8[0], setHuePosition = _useState8[1];
    useEffect(function () {
        // Update positions when color changes externally
        var saturationX = currentColor.hsv.s / 100 * 319;
        var brightnessY = 238 - currentColor.hsv.v / 100 * 238;
        var hueX = currentColor.hsv.h / 360 * 320;
        setPickerPosition({
            x: saturationX,
            y: brightnessY
        });
        setHuePosition(hueX);
    }, [currentColor.hsv]);
    useEffect(function () {
        // Update current color when defaultColor changes
        if (defaultColor) {
            var rgb = hexToRgb(defaultColor);
            var hsv = rgbToHsv(rgb.r, rgb.g, rgb.b);
            setCurrentColor({
                hex: defaultColor,
                rgb: rgb,
                hsv: hsv
            });
            var saturationX = hsv.s / 100 * 319;
            var brightnessY = 238 - hsv.v / 100 * 238;
            var hueX = hsv.h / 360 * 320;
            setPickerPosition({
                x: saturationX,
                y: brightnessY
            });
            setHuePosition(hueX);
        }
    }, [defaultColor]);
    var handleColorChange = function handleColorChange(newColor) {
        setCurrentColor(newColor);
    };
    var handlePickerPositionChange = function handlePickerPositionChange(position) {
        setPickerPosition(position);
    };
    var handleHuePositionChange = function handleHuePositionChange(position) {
        setHuePosition(position);
    };
    return /*#__PURE__*/ React.createElement(Container, {
        role: "region",
        "aria-label": "Color Picker"
    }, /*#__PURE__*/ React.createElement(ColorPickerArea, {
        currentColor: currentColor,
        onChange: handleColorChange,
        pickerPosition: pickerPosition,
        onPositionChange: handlePickerPositionChange
    }), /*#__PURE__*/ React.createElement(HuePicker, {
        currentColor: currentColor,
        onChange: handleColorChange,
        huePosition: huePosition,
        onHuePositionChange: handleHuePositionChange
    }), /*#__PURE__*/ React.createElement(ColorValues, {
        values: currentColor,
        onChange: handleColorChange
    }), /*#__PURE__*/ React.createElement(Button, {
        fullWidth: true,
        onClick: function onClick() {
            setColor(currentColor.hex);
        },
        color: "primary",
        variant: "contained"
    }, constants.apply));
};
export default PickerFull;
